import { arrayMove } from '@dnd-kit/sortable'

export function moveBirdviewTileRowOrder(order, activeId, overId) {
  const fromIndex = order.indexOf(activeId)
  const toIndex = order.indexOf(overId)

  return fromIndex < 0 || toIndex < 0 || fromIndex === toIndex
    ? order
    : arrayMove(order, fromIndex, toIndex)
}
